module.exports = __webpack_public_path__ + "static/img/质控管理@2x.9e61895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/质控管理@2x.png
// module id = 2MdA
// module chunks = 1